import { LegalPage, type LegalSection } from './LegalPage';

const SECTIONS: LegalSection[] = [
  {
    heading: 'What cookies are',
    body: [
      'Cookies are small files a website stores in your browser. We use a small number of them, and only for the reasons below.',
    ],
  },
  {
    heading: 'Essential cookies',
    body: [
      'These keep you signed in and the app working. We set a secure, httpOnly sign-in cookie so you stay logged in across page reloads — it can’t be read by JavaScript, which protects your session.',
      'Essential cookies can’t be turned off, because the service won’t work without them.',
    ],
  },
  {
    heading: 'Preference cookies',
    body: [
      'These remember choices like light or dark mode and your language (Bangla or English), so the app looks the way you left it.',
    ],
  },
  {
    heading: 'Analytics',
    body: [
      'We use privacy-respecting analytics to count visits and understand which features are used, so we can improve Possignin. These do not identify you personally and are not used for advertising.',
      'We do not run third-party advertising cookies or sell data to ad networks.',
    ],
  },
  {
    heading: 'Your control',
    body: [
      'You can clear or block cookies in your browser settings. Blocking essential cookies will sign you out and stop the app from working; blocking analytics or preference cookies is fine and won’t break anything.',
    ],
  },
  {
    heading: 'Contact',
    body: [
      'Questions about cookies? Email support@itcitysoft.com.',
    ],
  },
];

export function Cookies() {
  return (
    <LegalPage
      title="Cookie Policy"
      updated="14 June 2026"
      intro="We use as few cookies as possible — to keep you signed in, remember your preferences, and count visits."
      sections={SECTIONS}
    />
  );
}
